import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

const PATH_TEMPLATE = '/questionnaires/{questionnaireId}/section-template/{sectionTemplateId}/pdf-fill-json';
type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const createPdfFillJson = async ({
  questionnaireId,
  sectionTemplateId,
  jsonData,
  creatorId,
  userWorkflowDocumentId,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, {
    questionnaireId,
    sectionTemplateId,
  });
  const response = await formsBackendClient.post(path, {
    creatorId,
    jsonData,
    userWorkflowDocumentId,
  });
  return response.data;
};

export default createPdfFillJson;
